import { ArrowUp } from '@phosphor-icons/react';

export default ArrowUp;
